export const fonts = ['giphy', 'meme', 'fancy', 'pixel', 'subtitle'] as const
export type Font = typeof fonts[number]

export const mediaTypes = ['font', 'gif', 'image', 'video'] as const
export type MediaType = typeof mediaTypes[number]

export type Media = {
    source: File | string
    type: MediaType
}
